module.exports = __webpack_public_path__ + "static/media/experience.9370f709.svg";